import React from "react";
import BootstrapProvider from "@bootstrap-styled/provider";
import Loadable from "react-loadable";

import Fonts from "./../../global/Typography/Fonts";
import { HeaderHome } from "./../../components/Header/HeaderHome";
const Footer = Loadable({loader: () => import('../../components/Footer'), loading: () => null});
import {
  StyledContainerDesktop,
  StyledContainerTablet,
  StyledContainerMobile,
} from "./styles";
import GlobalStyle from "./../globalStyles";

const Layout = ({
                  context,
                  children,
                  clientContext,
                  newsletter = { showNewsletter: true },
                  childCategories = null,
                  isHomepage = false,
                }) => {
  let { isMobile, isTablet } = clientContext;
  let StyledContainer = StyledContainerMobile;

  if (isTablet) {
    StyledContainer = StyledContainerTablet;
  }
  if (!isMobile && !isTablet) {
    StyledContainer = StyledContainerDesktop;
  }

  return (
    <>
      <Fonts />
      <GlobalStyle />
      <BootstrapProvider utils={{
        display: false,
        print: false,
        clearfix: false,
        transition: false,
        cursor: false,
      }}>
        <main id="main">
          <HeaderHome
            context={context}
            clientContext={clientContext}
            childCategories={childCategories}
            isHomepage={isHomepage}
          />
          <StyledContainer isHomepage={isHomepage}>{children}</StyledContainer>
          <Footer
            context={context}
            clientContext={clientContext}
            newsletter={newsletter}
          />
        </main>
      </BootstrapProvider>
    </>
  );
};

export default Layout;
